import React, { useRef, useState } from "react";
import AgendaGestaoAtividades from "./AgendaGestaoAtividades/AgendaGestaoAtividades";
import PainelResumo from "./PainelResumo/PainelResumo";
import AgendaAtividades from "./AgendaAtividades/AgendaAtividades";
import useAsyncEffect from "../../../hooks/useAsyncEffect";
import { ListarCompromissosUsuarioController } from "../../../Controllers/Vendas/Usuario/UsuarioController";
import usePaginationFilter from "../../../hooks/usePaginationFilter";
import { IListarComprovantesUsuarioRequest } from "../../../Interfaces/Vendas/Usuario/UsuarioInterface";
import { Spinner } from "../../../Components/Loding/SpinnerPadrao";
import { IPropsTableChange } from "../../../Interfaces/Geral/Atendimento/AtendimentoInterfaces";
import AgendaAtividadeDetalhes from "./AgendaAtividades/AgendaAtividadesModal/AgendaAtividadeDetalhes";
import { IComponentModal } from "../../../Components/Modais/IModalComponent";
import { faBars, faCalendar } from "@fortawesome/free-solid-svg-icons";
import { EventClickArg } from "@fullcalendar/react";
import ModalComponent from "../../../Components/Modais";
import moment from "moment";
import { useModuloInfo } from "../../../Context/ModuloInfo";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export default function AgendaAtividadesComponent() {
    const { id } = useModuloInfo();

    const FILTRO_AGENDA_ATIVIDADES = sessionStorage.getItem(
        `FILTRO_AGENDA_ATIVIDADES_${id}`
    );

    const [calendarioAtividades, setCalendarioAtividades] = useState(
        localStorage.getItem("calendarioAtividades") === "true" ? true : false
    );

    const filtroInicial: IListarComprovantesUsuarioRequest = {
        DS_CLIENTE: "",
        DS_PESQUISA: "",
        DS_STATUS: "",
        ID_TIPO_ATIVIDADE: 0,
        ID_USUARIO_REQUEST: undefined,
        ID_TIPO_CASO: id ?? 0,
        DT_DATA_FN: moment().add(1, "months").format("YYYY-MM-DD"),
        DT_DATA_IN: moment().subtract(1, "months").format("YYYY-MM-DD"),
        ID_CASO: 0,
    };

    const ultimaPesquisaRef = useRef("");
    const [pesquisaText, setPesquisaText] = useState("");

    const [show, setShow] = useState(false);
    const [modal, setModal] = useState<IComponentModal>();

    const { filter, setFilter } =
        usePaginationFilter<IListarComprovantesUsuarioRequest>({
            page: 1,
            filter: FILTRO_AGENDA_ATIVIDADES
                ? JSON.parse(FILTRO_AGENDA_ATIVIDADES)
                : filtroInicial,
        });

    function handleSubmit(formData: IListarComprovantesUsuarioRequest) {
        const filterFormData = {
            ...formData,
        };
        setFilter(filterFormData);
        sessionStorage.setItem(
            `FILTRO_AGENDA_ATIVIDADES_${id}`,
            JSON.stringify(filterFormData)
        );
    }

    const {
        value: lstCompromissosUsuario,
        loading: lstCompromissosUsuarioLoading,
        execute: updateList,
    } = useAsyncEffect(async () => {
        return ListarCompromissosUsuarioController({
            DS_CLIENTE: filter?.DS_CLIENTE ? filter.DS_CLIENTE : "",
            DS_PESQUISA: filter?.DS_PESQUISA ? filter.DS_PESQUISA : "",
            DS_STATUS: filter?.DS_STATUS ? filter.DS_STATUS : "",
            DT_DATA_FN: filter?.DT_DATA_FN ? filter.DT_DATA_FN : undefined,
            DT_DATA_IN: filter?.DT_DATA_IN ? filter.DT_DATA_IN : undefined,
            ID_TIPO_ATIVIDADE: filter?.ID_TIPO_ATIVIDADE
                ? filter.ID_TIPO_ATIVIDADE
                : 0,
            ID_USUARIO_REQUEST: filter?.ID_USUARIO_REQUEST
                ? filter.ID_USUARIO_REQUEST
                : undefined,
            ID_TIPO_CASO: id ?? 0,
            ID_CASO: filter?.ID_CASO ? filter?.ID_CASO : 0,
        });
    }, [filter, calendarioAtividades]);

    const atividadesPlanejadas = lstCompromissosUsuario?.filter(
        (c) => c.DS_STATUS === "planejada"
    );
    const atividadesAtrasadas = lstCompromissosUsuario?.filter(
        (c) => c.DS_STATUS === "atrasada"
    );
    const atividadesExecutadas = lstCompromissosUsuario?.filter(
        (c) => c.DS_STATUS === "executada"
    );
    const atividadesParaHoje = lstCompromissosUsuario?.filter(
        (c) => c.DT_CASO_ATIVIDADE === new Date().toISOString().split("T")[0]
    );

    function handleSearch(searchValue: string, newState: IPropsTableChange) {
        ultimaPesquisaRef.current = searchValue;
        setTimeout(() => {
            if (ultimaPesquisaRef.current === searchValue) {
                setFilter({
                    ...filter,
                    DS_PESQUISA: newState.searchText,
                    DS_CLIENTE: filter?.DS_CLIENTE ? filter.DS_CLIENTE : "",
                    DS_STATUS: filter?.DS_STATUS ? filter.DS_STATUS : "",
                    ID_USUARIO_REQUEST: filter?.ID_USUARIO_REQUEST
                        ? filter.ID_USUARIO_REQUEST
                        : undefined,
                    DT_DATA_FN: filter?.DT_DATA_FN
                        ? filter.DT_DATA_FN
                        : undefined,
                    DT_DATA_IN: filter?.DT_DATA_IN
                        ? filter.DT_DATA_IN
                        : undefined,
                    ID_TIPO_ATIVIDADE: filter?.ID_TIPO_ATIVIDADE
                        ? filter.ID_TIPO_ATIVIDADE
                        : 0,
                    ID_TIPO_CASO: id ?? 0,
                    ID_CASO: filter?.ID_CASO ? filter?.ID_CASO : 0,
                });
            }
        }, 1500);
    }

    function eventClick(arg: EventClickArg) {
        const compromissos = lstCompromissosUsuario?.find(
            (a) => Number(a.ID_ATIVIDADE) === Number(arg.event.id)
        );

        if (compromissos) {
            setShow(true);
            setModal({
                headerComponent: "Atividade",
                IconHeader: faCalendar,
                Component: () => (
                    <AgendaAtividadeDetalhes
                        compromissos={compromissos}
                        updateList={updateList}
                    />
                ),
                noHeader: true,
                noFooter: true,
            });
        }
    }
    function AgendaAtividadeTable() {
        return (
            <AgendaAtividades
                filter={filter}
                handleSubmit={handleSubmit}
                filtroInicial={filtroInicial}
                handleSearch={handleSearch}
                lstCompromissosUsuario={lstCompromissosUsuario}
                FILTRO_AGENDA_ATIVIDADES={FILTRO_AGENDA_ATIVIDADES}
                lstCompromissosUsuarioLoading={lstCompromissosUsuarioLoading}
                pesquisaText={pesquisaText}
                setFilter={setFilter}
                setPesquisaText={setPesquisaText}
                updateList={updateList}
                calendarioAtividades={calendarioAtividades}
            />
        );
    }

    return (
        <div className="card p-4">
            <div className="d-flex justify-content-end">
                <button
                    className="btn btn-outline-primary"
                    onClick={() => {
                        setCalendarioAtividades((prev) => !prev);
                        localStorage.setItem(
                            "calendarioAtividades",
                            (!calendarioAtividades).toString()
                        );
                    }}
                >
                    <FontAwesomeIcon
                        icon={calendarioAtividades ? faCalendar : faBars}
                    />{" "}
                    {calendarioAtividades ? "Visão Calendário" : "Visão Tabela"}
                </button>
            </div>
            {!calendarioAtividades && (
                <div className="row">
                    <div className="col-md-5 p-4">
                        {/* <Agenda /> */}

                        <AgendaGestaoAtividades
                            lstCompromissosUsuario={lstCompromissosUsuario}
                            eventClick={eventClick}
                        />
                        {/* <div className="d-flex justify-content-end mr-3">
                        <button
                            className="btn btn-outline-danger"
                            onClick={() => {
                                setdateRange(null);
                            }}
                        >
                            Limpar filtro de data
                        </button>
                    </div> */}

                        {lstCompromissosUsuarioLoading && (
                            <span
                                className="position-absolute"
                                style={{
                                    left: "50%",
                                    top: "50%",
                                    zIndex: 999,
                                }}
                            >
                                <Spinner color="primary" />
                            </span>
                        )}
                    </div>
                    <div className="col-md-7 p-4">
                        <h5>
                            {moment(filter?.DT_DATA_IN).format("DD/MM/YYYY")} -{" "}
                            {moment(filter?.DT_DATA_FN).format("DD/MM/YYYY")}
                        </h5>
                        {/* <p>
                        Existe(m){" "}
                        {(atividadesPlanejadas?.length ?? 0) +
                            (atividadesExecutadas?.length ?? 0) +
                            (atividadesAtrasadas?.length ?? 0) +
                            (atividadesParaHoje?.length ?? 0)}{" "}
                        tarefa(s) para este dia.
                    </p> */}
                        <PainelResumo
                            totalPlanejadas={atividadesPlanejadas?.length ?? 0}
                            totalExecutadas={atividadesExecutadas?.length ?? 0}
                            totalAtrasadas={atividadesAtrasadas?.length ?? 0}
                            totalParaHoje={atividadesParaHoje?.length ?? 0}
                        />
                        {AgendaAtividadeTable()}
                    </div>
                </div>
            )}

            {calendarioAtividades && AgendaAtividadeTable()}

            <ModalComponent
                ModalComponent={modal}
                show={show}
                setShow={setShow}
            />
        </div>
    );
}
